/** @typedef {import('./SubscriptionCard/Props').SharedProps} Props */

import { translate } from '../../App/Internationalization';
import ExternalAnchorButton from '../ExternalAnchorButton';

import Loading from '../Loading';
import React from 'react';

const btnClass = 'button w-full p-3 text-ms-3';

/**
 * @param {Props} props
 * @returns	{JSX.Element}
 */

// eslint-disable-next-line complexity
function SubscribeButton(props) {
	const currentSubscription = props.subscription;

	if (props?.isGettingData || currentSubscription === null) {
		return (
			<div className={`${btnClass} pointer-events-none`}>
				<div className="-my-19 -scale-50">
					<Loading />
				</div>
			</div>
		);
	}

	const tier = props?.tier?.title;
	const url = props?.paymentLinks?.[tier]?.url;

	// Determine if this is the current plan
	const isCurrentTier =
		(currentSubscription?.isActive &&
			currentSubscription?.priceInCents === props.tier.pricePerMonth) ||
		(!currentSubscription?.isActive && props.tier.pricePerMonth === 0);

	// Determine label from planChangeStatus (success states from query params)
	let buttonText = translate('subscription.plans.cta'); // Default "Subscribe" or similar

	if (isCurrentTier) {
		buttonText = translate('subscription.plans.current_plan'); // e.g. "Current Plan"
	}

	/*
	 * if (isCurrentTier) {
	 * 	buttonText = translate('subscription.plans.current_plan'); // e.g. "Current Plan"
	 * } else {
	 * 	// If they have an active plan and this isn't it, it's either an upgrade or downgrade
	 * 	const currentPrice = currentSubscription?.priceInCents;
	 * 	const tierPrice = props.tier.pricePerMonth;
	 * 	if (tierPrice > currentPrice) {
	 * 		buttonText = translate('subscription.plans.upgrade'); // e.g. "Upgrade"
	 * 	} else {
	 * 		buttonText = translate('subscription.plans.downgrade'); // e.g. "Downgrade"
	 * 	}
	 * }
	 */

	if (isCurrentTier) {
		return (
			<button
				className={`${btnClass} !bg-theme-gray !text-theme-fg-light cursor-default`}
				disabled={true}
				type="button"
			>
				{buttonText}
			</button>
		);
	}

	return (
		<ExternalAnchorButton className={btnClass} href={url} target="_self">
			{buttonText}
		</ExternalAnchorButton>
	);
}

export default React.memo(SubscribeButton);
